import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { Category, PillDocumentsDTO, Tutorial } from '../model/training.model';

@Injectable({
  providedIn: 'root',
})
export class TrainingService {
  constructor(private _http: HttpClient) {}

  loadReleasesMandatories() {
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.SubUrlNotificationsActives, null);
  }

  postPrintJasperNotification(notificationId: string) {
    const params = new HttpParams().set('notificationId', notificationId);
    const httpOptions = {
      params: params,
      responseType: 'blob' as 'json',
    };
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.SubUrlNotificationsJasper, null, httpOptions);
  }

  getPdf(path: string) {
    const httpOptions = { responseType: 'blob' as 'json' };
    return this._http.get<any>(path, httpOptions);
  }

  getVideos = (categoryId: string, language: string) => {
    return this._http.post<Tutorial[]>(environment.URL_BASE_REQUEST + environment.subUrlTrainingPillTutorials, null, {
      params: { categoryId: categoryId, language: language },
    });
  };

  getTrainingFeatured = (lang: string) => {
    return this._http.post<any>(
      environment.URL_BASE_REQUEST + environment.subUrlTrainingPillFeatured + '?language=' + lang,
      null
    );
  };

  getCategories = (lang: string): Observable<Category[]> => {
    return this._http.post<any>(
      environment.URL_BASE_REQUEST + environment.subUrlTrainingPillCategories + '?language=' + lang,
      null
    );
  };

  getDocuments = (lang: string): Observable<PillDocumentsDTO[]> => {
    return this._http.post<any>(
      environment.URL_BASE_REQUEST + environment.subUrlTrainingPillDocuments + '?language=' + lang,
      null
    );
  };
}
